(() => {
if(window.vindictaGiftInstalled)return;
window.vindictaGiftInstalled=true;
let pending=null, failed=false;
const approved=new WeakSet();
const value='Oui — offerte (1 par commande)';
function sync(checked){document.querySelectorAll('[data-vd-gift-check]').forEach(e=>e.checked=checked);document.querySelectorAll('[data-vd-gift-value]').forEach(e=>e.value=checked?value:'');}
function errors(show){document.querySelectorAll('[data-vd-gift]').forEach(e=>{const p=e.querySelector('.vd-gift__error');p.hidden=!show;p.textContent=show?e.dataset.error:'';});}
document.addEventListener('change',event=>{
if(!event.target.matches('[data-vd-gift-check]'))return;
const checked=event.target.checked;
sync(checked);failed=false;errors(false);
document.querySelectorAll('[data-vd-gift-check]').forEach(e=>e.disabled=true);
document.querySelectorAll('.additional-checkout-buttons').forEach(e=>e.inert=true);
const task=fetch((window.Shopify?.routes?.root||'/')+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes:{'Pochette cadeau':checked?value:''}})}).then(r=>{if(!r.ok)throw Error('save');return r.json();}).then(()=>true).catch(()=>{failed=true;sync(!checked);errors(true);return false;}).finally(()=>{document.querySelectorAll('[data-vd-gift-check]').forEach(e=>e.disabled=false);document.querySelectorAll('.additional-checkout-buttons').forEach(e=>e.inert=false);pending=null;});
pending=task;
});
document.addEventListener('submit',async event=>{
const form=event.target;
if(!form.querySelector('[data-vd-gift]')||approved.has(form))return;
if(!pending&&!failed)return;
event.preventDefault();event.stopImmediatePropagation();
const submitter=event.submitter;
const ok=pending?await pending:!failed;
if(!ok){errors(true);return;}
approved.add(form);try{form.requestSubmit(submitter||undefined);}finally{approved.delete(form);}
},true);
})();